import styled from 'styled-components';
import { darken } from 'polished';

import 'antd/es/modal/style/index.css';
import 'antd/lib/spin/style/index.css';

export const PageTitle = styled.div`
  margin: 0px auto 0px auto;
  width: auto;
  max-width: 1068px;
  background-color: #fff;
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
`;

export const BoxButtonReload = styled.div`
  max-width: 1070px;
  width: 100%;
  margin: 0px auto;
`;

export const ButtonReload = styled.div`
  div {
    button {
      margin-bottom: 15px;
      background: #74a50a;
      max-width: 74px;
      height: 34px;
      border-radius: 3.5px;
      padding: 5px 10px 5px 10px;
      color: #fff;
      border: 0;
      font-size: 13px;
      transition: background 0.2s;
      z-index: 200;
      position: relative;
      &:hover {
        background: ${darken(0.03, '#74a50a')};
      }
      svg {
        align-self: center;
      }
    }
  }
`;

export const ContainerFull = styled.div`
  width: 100%;
  background-color: rgb(245, 245, 245);
  display: flex;
  flex-direction: column;
  justify-content: center;
  div.ContainerBreadcumbs {
    background-color: #fff;
    z-index: 180;
    width: 100%;
  }
`;

export const ContainerAlign = styled.div`
  width: 100%;
  max-width: 1085px;
  margin: 0px auto;
  padding-bottom: 15px;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1170px;
  margin: -60px auto 0px auto;
  height: 8660px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  header {
    display: flex;
    align-self: center;
    align-items: center;

    button {
      border: 0;
      background: none;
    }

    strong {
      color: #222;
      font-size: 24px;
      margin: 0 15px;
    }
  }

  div.headerIframe {
    width: 100%;
    height: 120px;
    background-color: #fff;
    position: relative;
  }

  iframe {
    margin-top: -130px;
    min-height: 900px;
    width: 100%;
    height: 100%;
    z-index: 10;
  }

  form.form {
    display: none;
  }
`;

export const ModalContainer = styled.div`
  div.ModalBody {
    width: 480px;
    height: 120px;
    margin-top: 5px;

    margin-left: -24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 47px 0 45px;
    background-color: #f4c2c2;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: 0.01px;
    color: #cc0000;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 30px;

  div.iconModal {
    width: 80px;
    height: 80px;
    margin-right: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      width: 50px;
      height: 50px;
      display: block;
      border-radius: 50%;
      background-color: #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    svg {
      color: #cc0000;
    }
  }

  h2 {
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
    span {
      color: #cc0000;
      font-weight: bold;
    }
  }
`;

export const ModalFooter = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const ButtonModal = styled.button`
  width: 168.8px;
  height: 40.1px;
  border-radius: 3.5px;
  border: none;
  background-color: ${props => (props.cancel ? '#FFF' : '#cc0000')};
  color: ${props => (props.cancel ? '#999999' : '#FFF')};
  margin: 20px 10px 0px 10px;
`;
